import { DEBUG } from '@glimmer/env';

import { DEFAULT_LOCALE } from '@repo/shared-config/app/constants/locales';
import IntlServiceBase from 'ember-intl/services/intl';

export default class IntlService extends IntlServiceBase {
  // https://ember-intl.github.io/ember-intl/docs/migration/v7#minimized-api-of-the-intl-service
  lookup(translationKey: string): string | undefined {
    return this.getTranslation(translationKey, this.primaryLocale || DEFAULT_LOCALE);
  }

  get locale() {
    if (DEBUG) {
      // eslint-disable-next-line no-console
      console.warn('locale is deprecated, use intl.primaryLocale instead');
    }
    // @ts-expect-error Accessing private member
    return this._locale;
  }

  // This is a proxy to an ember-intl internal property, this has been changed in ember-intl v7.0.0
  // https://ember-intl.github.io/ember-intl/docs/migration/v7#minimized-api-of-the-intl-service
  translationsFor(...args: [string]): Record<string, string> {
    if (DEBUG) {
      // eslint-disable-next-line no-console
      console.warn('translationsFor is deprecated');
    }
    // @ts-expect-error Accessing private member
    return this._intls[args[0]].messages;
  }
}
